import React, { Component } from 'react';

import { Link } from 'react-router-dom';
import { FormattedMessage } from 'react-intl';

// Styles
import styles from '../styles/header.scss';
import APP_ROUTES from '../../../constants/app-routes';
import KWalletActivateModal from '../kwallet-activation-modal';

const pageWallet = 'kwallet';

class UserMenu extends Component {
    constructor(props) {
        super(props);
        this.container = React.createRef();
        this.state = {
            showUserMenu: false,
            showActivateKWallet: false,
            token: props.access_token,
        };

        this.toggleUserMenu = this.toggleUserMenu.bind(this);
        this.handleKWalletActivateModal = this.handleKWalletActivateModal.bind(this);
        this.checkForActiveWallet = this.checkForActiveWallet.bind(this);
    }

    onLogout() {
        this.toggleUserMenu();
        this.props.logout();
    }

    handleClickOutside = (event) => {
        if (this.container.current && !this.container.current.contains(event.target)) {
            document.removeEventListener('mousedown', this.handleClickOutside);
            this.setState({
                showUserMenu: false,
            });
        }
    };

    handleKWalletActivateModal = async (result) => {
        if (result) {
            const activate = await this.props.activateWallet(this.state.token, pageWallet);
            this.setState({
                showActivateKWallet: false,
            });
            if (activate) {
                window.location.assign(APP_ROUTES.manageKWallet);
            }
        } else {
            this.setState({
                showActivateKWallet: false,
            });
        }
    };

    checkForActiveWallet = async (wallet) => {
        const result = await this.props.isWalletActive(this.props.access_token, pageWallet);
        if (result) {
            window.location.assign(APP_ROUTES.manageKWallet);
        } else {
            this.setState({
                showActivateKWallet: true,
            });
        }
    }

    toggleUserMenu() {
        this.setState(
            (prevState) => ({ showUserMenu: !prevState.showUserMenu }),
            () => {
                if (this.state.showUserMenu) {
                    document.addEventListener('mousedown', this.handleClickOutside);
                } else {
                    document.removeEventListener('mousedown', this.handleClickOutside);
                }
            },
        );
    }

    render() {
        const { user } = this.props;

        return (
            // eslint-disable-next-line react/jsx-fragments
            <React.Fragment>
                <li className="dropdown config" ref={this.container}>
                    <a className={`dropdown-toggle line-double ${styles.lineDouble}`} onClick={this.toggleUserMenu}>
                        <span className="text">
                            <i className="pe-7f-user pe-lg pe-va" />
                            <span className={styles.hello}>
                                <FormattedMessage id="hello" defaultMessage="Hello!" />
                            </span>
                            <span>{user.email.split('@')[0]}</span>
                        </span>
                        <i className={`pe-7s-angle-down pe-1x pe-va font-weight-bold ${styles.angleDown}`} style={{ display: this.state.showUserMenu ? 'none' : 'inline-block' }} />
                        <i className={`pe-7s-angle-up pe-1x pe-va font-weight-bold ${styles.angleUp}`} style={{ display: this.state.showUserMenu ? 'inline-block' : 'none' }} />
                    </a>

                    <ul className={`dropdown-menu ${styles.userMenuDropdowns}`} style={{ display: this.state.showUserMenu ? 'block' : 'none' }}>
                        <li onClick={() => this.toggleUserMenu()}>
                            <Link to={APP_ROUTES.orders}>
                                <span className={`pe-7s pe-7s-user ${styles.userMenuIcon}`} />
                                <FormattedMessage id="my-orders" defaultMessage="My Orders" />
                            </Link>
                            {process.env.REACT_APP_KWALLET_ENABLED === 'true' && (
                                <a onClick={() => this.checkForActiveWallet(pageWallet)}>
                                    <span className={`pe-7s pe-7s-user ${styles.userMenuIcon}`} />
                                    <FormattedMessage id="manage-k-wallet" defaultMessage="Administrar K-Wallet" />
                                </a>
                            )}
                        </li>
                        {/* <li>
                        <Link to={APP_ROUTES.profile}>
                            <span className={`pe-7s pe-7s-note2 ${styles.userMenuIcon}`} />
                            <FormattedMessage id="manage-profile" defaultMessage="Manage Profile" />
                        </Link>
                    </li> */}
                        {/*
                    <li>
                        <Link to={APP_ROUTES.offers}>
                            <span className={`pe-7s pe-7s-gift ${styles.userMenuIcon}`} />
                            <FormattedMessage id="my-bids-and-offers" defaultMessage="My Bids & Offers" />
                        </Link>
                    </li>
                    <li>
                        <Link to={APP_ROUTES.conversations}>
                            <span className={`pe-7s pe-7s-mail ${styles.userMenuIcon}`} />
                            <FormattedMessage id="conversations" defaultMessage="Conversations" />
                        </Link>
                    </li>
                    <li>
                        <Link to={APP_ROUTES.notifications}>
                            <span className={`pe-7s pe-7s-bell ${styles.userMenuIcon}`} />
                            <FormattedMessage id="notifications" defaultMessage="Notifications" />
                        </Link>
                    </li> */}
                        <li>
                            <a onClick={() => this.onLogout()}>
                                <FormattedMessage id="logout" defaultMessage="Logout" />
                            </a>
                        </li>
                    </ul>
                </li>
                <KWalletActivateModal isOpen={this.state.showActivateKWallet} handleClose={this.handleKWalletActivateModal} />
            </React.Fragment>
        );
    }
}

export default UserMenu;



/** WEBPACK FOOTER **
 ** ./src/components/shared/header/user-menu.jsx
 **/